import React from "react";
import Loader from "../../Loader";
import { formStyles } from "../formStyles";

export default function RepresentativeDetailsStep(props) {
  const { register, inputs, handleChange, handleSubmit, verifyCorporateReporter, onSubmitReporter, isLoading, isVerifyingNewOwner, states, lgs, ownerDetails, setOwnerDetails, setStep } = props;

  return (
    <div className={formStyles.card}>
      <h2 className={formStyles.header}>Representative Details (Corporate)</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className={formStyles.label}>Organization Name</label>
          <input type="text" name="first_name" readOnly value={ownerDetails.first_name || ""} onChange={handleChange} className={formStyles.input} placeholder="Auto-filled from ID" />
        </div>
        <div>
          <label className={formStyles.label}>Organization Address</label>
          <input type="text" {...register("present_address", { required: !ownerDetails.registered_address })} readOnly={!!ownerDetails.registered_address} value={ownerDetails.registered_address || inputs.present_address || ""} onChange={handleChange} className={formStyles.input} />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6 items-end">
        <div>
          <label className={formStyles.label}>Org Rep ID Type</label>
          <select {...register("r_id_type", { required: true })} onChange={handleChange} className={formStyles.input}>
            <option value="">Select ID Type</option>
            <option value="nin">National Identification Number (NIN)</option>
          </select>
        </div>
        <div>
          <label className={formStyles.label}>Rep ID Number</label>
          <input type="text" name="r_id_number" onChange={handleChange} className={`${formStyles.input} uppercase`} />
        </div>
        <div>
          <button onClick={verifyCorporateReporter} className={`${formStyles.buttonPrimary} w-full py-[14px]`}>
            Verify Rep {isVerifyingNewOwner && <span className="ml-2"><Loader /></span>}
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div>
          <label className={formStyles.label}>Rep First Name</label>
          <input type="text" readOnly value={inputs.r_first_name || ""} className={formStyles.input} />
        </div>
        <div>
          <label className={formStyles.label}>Rep Middle Name</label>
          <input type="text" readOnly value={inputs.r_middle_name || ""} className={formStyles.input} />
        </div>
        <div>
          <label className={formStyles.label}>Rep Last Name</label>
          <input type="text" readOnly value={inputs.r_last_name || ""} className={formStyles.input} />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div>
          <label className={formStyles.label}>Rep Phone</label>
          <input type="text" {...register("r_phone", { required: true })} onChangeCapture={handleChange} value={inputs.r_phone || ""} className={formStyles.input} />
        </div>
        <div>
          <label className={formStyles.label}>Rep Email</label>
          <input type="email" {...register("email", { required: true })} onChangeCapture={handleChange} value={inputs.email || ""} className={formStyles.input} />
        </div>
        <div>
          <label className={formStyles.label}>Gender</label>
          <select {...register("r_gender", { required: true })} onChangeCapture={handleChange} value={inputs.r_gender || ""} className={formStyles.input}>
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className={formStyles.label}>State of Residence</label>
          <select {...register("r_state", { required: true })} onChangeCapture={handleChange} className={formStyles.input}>
            <option value="">Select State</option>
            {states.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
        </div>
        <div>
          <label className={formStyles.label}>LGA of Residence</label>
          <select {...register("r_lga", { required: true })} onChangeCapture={handleChange} className={formStyles.input}>
            <option value="">Select LGA</option>
            {lgs.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
        </div>
      </div>

      <div className="flex justify-between items-center mt-10 pt-6 border-t border-gray-200">
        <button type="button" onClick={() => setStep(1)} className={formStyles.buttonSecondary}>&laquo; Previous</button>
        <button type="button" onClick={handleSubmit(onSubmitReporter)} className={formStyles.buttonPrimary}>
          Next &raquo; {isLoading && <span className="ml-2"><Loader /></span>}
        </button>
      </div>
    </div>
  );
}